import script from "./FitterStatsDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./FitterStatsDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./FitterStatsDashboardView.vue?vue&type=style&index=0&id=7fd0002f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fd0002f"]])

export default __exports__